import { render } from "./RankUpSection.vue?vue&type=template&id=23ff6e16&scoped=true"
import script from "./RankUpSection.vue?vue&type=script&lang=js"
export * from "./RankUpSection.vue?vue&type=script&lang=js"

import "./RankUpSection.vue?vue&type=style&index=0&id=23ff6e16&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ff6e16"]])

export default __exports__